const Form048TC = {
    stepName: {
        importantNotes: "重要事項",
        receipt: "繳費收據",
        confirmation: "確認",
        schoolInformation: "學校信息",
    },
    label: {
        noteTitle: "個人資料收集聲明",
        noteDetails:
            "「其他費用」只適用於在緊接2005年9月前向社會福利署領取有關津貼的幼兒中心。",
        title: "個人資料收集聲明",
        statement: "本人已閱讀、明白及同意上述條款及細則。",
        iamSmartStatement:
            "本人理解申請人和學校審批人需要擁有「智方便+」帳戶才能處理申請。",
        receiptType: "收據類型",
        refundTips: "請發還本校所繳交的下列「其他費用」",
        chargesGp: {
            month: "月份",
            startDate: "開始日期",
            startDateLowerCase: "開始日期",
            endDate: "結束日期",
            start_end_date: "開始／結束日期",
            managedCost: "管理費（港幣 $）",
            ACFee: "冷氣費（港幣 $）",
            attachment: {
                tips: "現付上繳費的收據(或已核證的收據副本)，以供查考。",
                managementFee: "附件（管理費）",
                acFee: "附件（冷氣費）",

                others: "附件（其他）",
            },
        },
        contact: {
            supervisorName: "校監姓名",
            schoolName: "學校名稱",
            personName: "聯絡人姓名",
            telephone: "電話號碼",
        },
        header: {
            headerOne: "重要事項",
        },
        dateTypeCode: {
            month: "月份",
            start_end_date: "開始／結束日期",
        },
        specialCharacter: {
            slash: "／",
        },
        applicantInformation: "申請人信息",
    },
    impNotes: {
        note1: "「其他費用」只適用於在緊接2005年9月前向社會福利署領取有關津貼的幼兒中心。 ",
        note2: "沒有「智方便+」戶口的申請人須把已填妥的申請表交回幼稚園及幼兒中心聯合辦事處處理（地址：香港太古城太古灣道14號6樓602室）。請確保已為郵件支付足夠郵資，以免未能送達本局。郵資不足的郵件，一律會由香港郵政處理。",
    },
    noteList: {
        title1: "收集個人資料的目的",
        title2: "可獲轉移資料者",
        title3: "查閱個人資料",
        note1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        note1a: "就發還「其他費用」，辦理有關處理、核實及查證的事務；",
        note1b: "就上文(a)項所述的處理、核實及查證，辦理有關把個人資料與政府相關政策局／部門資料庫進行核對程序的事務；",
        note1c: "為核實／更新教育局的記錄，辦理有關把個人資料與教育局資料庫進行核對程序的事務；",
        note1d: "辦理有關培訓及發展的事務，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        note1e: "辦理有關處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計的事務；",
        note1f: "辦理有關編製統計資料、研究材料及政府刊物的事務；以及",
        note1g: "辦理有關施行及強制執行規則及規例 [包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》)]的事務；及《幼兒服務條例》(香港法例第243章)及其附屬法例 [即《幼兒服務規例》(香港法例第243A章)]的事務 ",
        note2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理。",
        note3: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        note3a: "政府其他政策局及部門，以用於上文第1段所述的用途；",
        note3b: "與本表格相關的學校，以用於上文第1段所述的用途；",
        note3c: "你曾就披露個人資料給予訂明同意；以及",
        note3d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        note4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港太古城太古灣道14號6樓602室幼稚園及幼兒中心聯合辦事處當值主任或電郵至 ",
        email: "jokc@edb.gov.hk",
        noteEnd: "。",
    },
    receiptType: {
        // receipt: "繳費的收據",
        photocopy: "上傳已核證的收據副本",
        remark: {
            title: "備註",
            content: "每個文件的最大大小為10MB",
            content2: "可接受的文件類型：jpeg, jpg, png, pdf, zip",
            content3: "最大文件數：20",
        },
    },
    errorMsg: {
        amount: {
            min: "請輸入一個有效的價格",
            max: "價格最多必6位數",
            maxDecimal: "價格必須為小數後2位",
        },
        atLeastOne: "請輸入管理費/冷氣費",
        na: "不適用",
    },
};
export default Form048TC;
